<template>
  <component
    :is="component"
    :value="value"
    :data="data"
    :disabled="disabled"
    :isSlot="isSlot"
    @input="$emit('input', $event)"
  />
</template>

<script>
import ProjectThemeSelector from '@/components/Project/StepsFields/ThemeSelector.vue'
import PageThemeSelector from '@/components/Page/StepsFields/ThemeSelector.vue'

export default {
  props: {
    data: { type: Object, default: () => ({}) },
    value: String,
    disabled: Boolean,
    isSlot: Boolean,
  },
  computed: {
    component() {
      return this.data.ofType === 'Page' ? PageThemeSelector : ProjectThemeSelector
    },
  },
  components: { ProjectThemeSelector, PageThemeSelector },
}
</script>
